import { useState } from "react";
import Icon from "../components/Icon";
import { Avatar, BtnPrimary, BtnGhost } from "../components/Atoms";
import * as api from "../api";
import Campo from "../components/forms/Campo";
import { nombreRol, esSuper, esAdmin, esGestor } from "../utils";

export default function ProfilePage({user, users, setUsers, notifs, setNotifs, teams}) {
  const [tab,         setTab       ] = useState("profile");
  const [pwdForm,     setPwdForm   ] = useState({current:"",next:"",confirm:""});
  const [pwdMsg,      setPwdMsg    ] = useState(null);
  const [nameForm,    setNameForm  ] = useState(user.name);
  const [nameMsg,     setNameMsg   ] = useState(null);
  const [editUserId,  setEditUserId] = useState("hidden");
  const [userForm,    setUserForm  ] = useState({name:"",email:"",role:"member",pwd:""});
  const [userMsg,     setUserMsg   ] = useState(null);
  const isSuper  = esSuper(user);
  const isAdmin  = esAdmin(user);
  const isGestorUser = esGestor(user);
  const unread   = notifs.filter(n=>!n.read).length;
  const inS={width:"100%",padding:"9px 11px",borderRadius:8,border:"1px solid var(--border)",fontSize:13,fontFamily:"var(--font)",boxSizing:"border-box",background:"var(--surface2)",color:"var(--text)",marginBottom:10};
  const lbS={fontSize:10,color:"var(--text3)",fontWeight:700,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:".06em"};

  const handlePwdChange = async () => {
    if(pwdForm.next.length<6){setPwdMsg({ok:false,txt:"Mínimo 6 caracteres"});return;}
    if(pwdForm.next!==pwdForm.confirm){setPwdMsg({ok:false,txt:"Las contraseñas no coinciden"});return;}
    try {
      await api.changePassword(pwdForm.current, pwdForm.next);
      setPwdMsg({ok:true,txt:"Contraseña actualizada correctamente"});
      setPwdForm({current:"",next:"",confirm:""});
    } catch(e) {
      setPwdMsg({ok:false,txt:e.message||"Contraseña actual incorrecta"});
    }
  };
  const handleNameChange = async () => {
    if(!nameForm.trim()){setNameMsg({ok:false,txt:"El nombre no puede estar vacío"});return;}
    try {
      await api.updateUser(user.id, {name:nameForm.trim(),email:user.email,role:user.role});
      setNameMsg({ok:true,txt:"Nombre actualizado correctamente"});
      setTimeout(()=>setNameMsg(null),2500);
    } catch(e) {
      setNameMsg({ok:false,txt:e.message||"Error al actualizar nombre"});
    }
  };

  const handleSaveUser = () => {
    if(!userForm.name.trim()||!userForm.email.trim()){setUserMsg({ok:false,txt:"Nombre y email obligatorios"});return;}
    if(users.find(u=>u.email===userForm.email&&u.id!==editUserId)){setUserMsg({ok:false,txt:"Email ya en uso"});return;}
    if(editUserId===null) {
      if(!userForm.pwd){setUserMsg({ok:false,txt:"La contraseña inicial es obligatoria"});return;}
      setUsers(prev=>[...prev,{...userForm,id:Math.random().toString(36).slice(2,8),active:true}]);
      setUserMsg({ok:true,txt:"Usuario creado correctamente"});
      setTimeout(()=>{setEditUserId("hidden");setUserMsg(null);},1200);
    } else {
      setUsers(prev=>prev.map(u=>u.id===editUserId?{...u,name:userForm.name,email:userForm.email,role:userForm.role,...(userForm.pwd?{pwd:userForm.pwd}:{})}:u));
      setUserMsg({ok:true,txt:"Usuario actualizado correctamente"});
      setTimeout(()=>{setEditUserId("hidden");setUserMsg(null);},1200);
    }
    setUserForm({name:"",email:"",role:"member",pwd:""});
  };

  const card={background:"var(--surface)",borderRadius:13,border:"1px solid var(--border)",boxShadow:"var(--shadow-sm)"};
  const tabs=[
    ["profile","person-badge","Mi perfil"],
    ["alerts","bell","Alertas"],
  ];

  return (
    <div style={{maxWidth:860,margin:"0 auto"}}>
      {/* Header de perfil */}
      <div style={{...card,padding:20,marginBottom:18,display:"flex",alignItems:"center",gap:16}}>
        <div style={{width:60,height:60,borderRadius:"50%",background:"linear-gradient(135deg,#086C76,#087DAB)",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:26,flexShrink:0}}>
          {user.name[0].toUpperCase()}
        </div>
        <div style={{flex:1}}>
          <div style={{fontWeight:700,fontSize:18,marginBottom:3}}>{user.name}</div>
          <div style={{fontSize:12,color:"var(--text3)",marginBottom:6}}>{user.email}</div>
          <span style={{fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:20,background:isAdmin?"#fef9c3":isGestorUser?"#f0fdf4":"var(--accent-bg)",color:isAdmin?"#a16207":isGestorUser?"#15803d":"var(--accent)"}}>
            {nombreRol(user.role)}
          </span>
        </div>
        {unread>0&&<div style={{textAlign:"center"}}>
          <div style={{fontSize:22,fontWeight:800,color:"var(--accent)"}}>{unread}</div>
          <div style={{fontSize:10,color:"var(--text3)"}}>alerta{unread!==1?"s":""} sin leer</div>
        </div>}
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:3,marginBottom:18,background:"var(--surface)",borderRadius:11,padding:4,border:"1px solid var(--border)",boxShadow:"var(--shadow-sm)"}}>
        {tabs.map(([v,ic,lb])=>(
          <button key={v} className="btn" onClick={()=>setTab(v)}
            style={{flex:1,padding:"9px 12px",borderRadius:8,border:"none",cursor:"pointer",fontSize:12.5,fontWeight:tab===v?700:400,fontFamily:"var(--font)",display:"flex",alignItems:"center",justifyContent:"center",gap:6,transition:"all .15s",
              background:tab===v?"linear-gradient(135deg,#086C76,#087DAB)":"transparent",
              color:tab===v?"#fff":"var(--text3)",boxShadow:tab===v?"0 2px 8px rgba(0,180,216,.25)":"none"}}>
            <Icon name={ic} size={13} color={tab===v?"#fff":"var(--text3)"}/>{lb}
            {v==="alerts"&&unread>0&&<span style={{width:16,height:16,borderRadius:"50%",background:tab===v?"rgba(255,255,255,.3)":"var(--danger)",color:"var(--on-danger)",fontSize:10,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center"}}>{unread}</span>}
          </button>
        ))}
      </div>

      {/* ── Tab: Mi perfil ── */}
      {tab==="profile"&&(
        <div className="grid-1col-mob" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          {/* Nivel de acceso */}
          <div style={{...card,padding:18}}>
            <div style={{fontWeight:700,fontSize:12,marginBottom:12,display:"flex",alignItems:"center",gap:6}}>
              <Icon name="shield-lock" size={14} color="var(--accent)"/>Nivel de acceso
            </div>
            <div style={{fontSize:12.5,lineHeight:1.8,color:"var(--text2)",marginBottom:14}}>
              {isSuper
                ? <span>Como <b>Super usuario</b> tienes acceso a todos los equipos: gestionas usuarios y equipos, modificas cualquier tarea y eres quien puede nombrar a otros super usuarios.</span>
                : isAdmin
                ? <span>Como <b>Administrador</b> ves a toda la plantilla y todos los equipos, y gestionas lo de tus equipos: sus personas, su cuaderno, su jornada y sus ausencias.</span>
                : isGestorUser
                  ? <span>Como <b>Gestor</b> tienes control total sobre proyectos y tareas, y consultas la plantilla, los equipos, el registro de jornada de tu equipo y el cuadrante de guardias. Crear y editar usuarios sigue siendo del administrador.</span>
                  : <span>Como <b>Usuario</b> tienes acceso a tu Cuaderno y proyectos asignados. Puedes reasignar tareas dentro de tu equipo.</span>}
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              {(isSuper?[
                ["check-circle-fill","#22c55e","Acceso a todos los equipos y proyectos"],
                ["check-circle-fill","#22c55e","Gestionar usuarios y contraseñas"],
                ["check-circle-fill","#22c55e","Gestionar equipos de trabajo"],
                ["check-circle-fill","#22c55e","Reasignar tareas libremente"],
                ["check-circle-fill","#22c55e","Nombrar y quitar super usuarios"],
              ]:isAdmin?[
                ["check-circle-fill","#22c55e","Ver a toda la plantilla y todos los equipos"],
                ["check-circle-fill","#22c55e","Gestionar a las personas de tus equipos"],
                ["check-circle-fill","#22c55e","Cuaderno, jornada y ausencias de tus equipos"],
                ["check-circle-fill","#22c55e","Cambiar el nombre y el color de tus equipos"],
              ]:isGestorUser?[
                ["check-circle-fill","#22c55e","Crear y gestionar proyectos"],
                ["check-circle-fill","#22c55e","Invitar miembros a proyectos"],
                ["check-circle-fill","#22c55e","Crear, editar y reasignar tareas"],
                ["check-circle-fill","#22c55e","Gestionar equipos de trabajo"],
                ["check-circle-fill","#22c55e","Consultar la lista de usuarios"],
                ["check-circle-fill","#22c55e","Ver la jornada de su equipo y las guardias"],
                ["x-lg","#ef4444","No crea ni edita usuarios"],
              ]:[
                ["check-circle-fill","#22c55e","Cuaderno personal"],
                ["check-circle-fill","#22c55e","Ver proyectos asignados"],
                ["check-circle-fill","#22c55e","Reasignar tareas de su equipo"],
                ["x-lg","#ef4444","No puede gestionar usuarios"],
                ["x-lg","#ef4444","Incidencias y guardias: solo el equipo TIC"],
              ]).map(([ic,cl,txt])=>(
                <div key={txt} style={{display:"flex",alignItems:"center",gap:7,fontSize:12}}>
                  <Icon name={ic} size={12} color={cl}/><span>{txt}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Columna derecha: datos personales + contraseña */}
          <div style={{display:"flex",flexDirection:"column",gap:16}}>
            {/* Datos personales */}
            <div style={{...card,padding:18}}>
              <div style={{fontWeight:700,fontSize:12,marginBottom:12,display:"flex",alignItems:"center",gap:6}}>
                <Icon name="person-badge" size={14} color="var(--accent)"/>Datos personales
              </div>
              <Campo><label style={lbS}>Nombre completo</label>
              <input value={nameForm} onChange={e=>setNameForm(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&handleNameChange()}
                style={inS} placeholder="Tu nombre completo"/></Campo>
              <Campo><label style={lbS}>Email</label>
              <input value={user.email} disabled
                style={{...inS,opacity:.6,cursor:"not-allowed"}}/></Campo>
              {nameMsg&&<div style={{padding:"8px 12px",borderRadius:8,fontSize:12,marginBottom:10,background:nameMsg.ok?"#f0fdf4":"#fef2f2",color:nameMsg.ok?"#15803d":"#dc2626",border:"1px solid "+(nameMsg.ok?"var(--ok-line)":"var(--red-line)")}}>{nameMsg.txt}</div>}
              <BtnPrimary onClick={handleNameChange} style={{width:"100%",justifyContent:"center"}}>
                <Icon name="floppy2-fill" size={13} color="#fff"/>Guardar nombre
              </BtnPrimary>
            </div>
            {/* Cambiar contraseña */}
            <div style={{...card,padding:18}}>
              <div style={{fontWeight:700,fontSize:12,marginBottom:12,display:"flex",alignItems:"center",gap:6}}>
                <Icon name="key" size={14} color="var(--accent)"/>Cambiar contraseña
              </div>
              {[["Contraseña actual","current"],["Nueva contraseña","next"],["Confirmar nueva","confirm"]].map(([lb,k])=>(
                <div key={k}><Campo><label style={lbS}>{lb}</label>
                <input type="password" value={pwdForm[k]} onChange={e=>setPwdForm(p=>({...p,[k]:e.target.value}))} style={inS}/></Campo></div>
              ))}
              {pwdMsg&&<div style={{padding:"8px 12px",borderRadius:8,fontSize:12,marginBottom:10,background:pwdMsg.ok?"#f0fdf4":"#fef2f2",color:pwdMsg.ok?"#15803d":"#dc2626",border:"1px solid "+(pwdMsg.ok?"var(--ok-line)":"var(--red-line)")}}>{pwdMsg.txt}</div>}
              <BtnPrimary onClick={handlePwdChange} style={{width:"100%",justifyContent:"center"}}>
                <Icon name="key" size={13} color="#fff"/>Actualizar contraseña
              </BtnPrimary>
            </div>
          </div>
        </div>
      )}

      {/* ── Tab: Alertas ── */}
      {tab==="alerts"&&(
        <div style={{...card,padding:18}}>
          <div style={{fontWeight:700,fontSize:12,marginBottom:14,display:"flex",alignItems:"center",gap:6,justifyContent:"space-between"}}>
            <span style={{display:"flex",alignItems:"center",gap:6}}><Icon name="bell" size={14} color="var(--accent)"/>Notificaciones</span>
            {unread>0&&<button className="btn" onClick={()=>setNotifs(prev=>prev.map(n=>({...n,read:true})))}
              style={{padding:"4px 10px",borderRadius:7,border:"1px solid var(--border)",background:"var(--bg)",cursor:"pointer",fontSize:11,fontFamily:"var(--font)",color:"var(--text2)"}}>
              Marcar todas leídas
            </button>}
          </div>
          {notifs.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:"var(--text3)",fontSize:13}}>Sin notificaciones</div>}
          <div style={{display:"flex",flexDirection:"column",gap:7}}>
            {notifs.map(n=>(
              <div key={n.id} style={{padding:"11px 14px",borderRadius:10,border:"1px solid "+(n.read?"var(--border2)":"var(--accent)44"),background:n.read?"var(--bg)":"#f0f9ff",display:"flex",alignItems:"flex-start",gap:10}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:n.read?"#d1d5db":"var(--accent)",flexShrink:0,marginTop:5}}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:12.5,fontWeight:n.read?400:600,lineHeight:1.4}}>{n.msg}</div>
                  <div style={{fontSize:10,color:"var(--text3)",marginTop:3}}>{new Date(n.created_at||n.ts).toLocaleString("es-ES",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"})}</div>
                </div>
                {!n.read&&(
                  <button className="btn" onClick={()=>setNotifs(prev=>prev.map(x=>x.id===n.id?{...x,read:true}:x))}
                    style={{padding:"3px 9px",borderRadius:6,border:"1px solid var(--accent)44",background:"var(--accent-bg)",color:"var(--accent)",cursor:"pointer",fontSize:10,fontWeight:700,fontFamily:"var(--font)",display:"flex",alignItems:"center",gap:3,flexShrink:0}}>
                    <Icon name="check2" size={10} color="var(--accent)"/>Leída
                  </button>
                )}
                <button aria-label="Descartar notificación" className="btn" onClick={()=>setNotifs(prev=>prev.filter(x=>x.id!==n.id))}
                  style={{minWidth:24,minHeight:24,alignItems:"center",justifyContent:"center",display:"inline-flex",background:"none",border:"none",cursor:"pointer",padding:2,display:"flex",opacity:.8,flexShrink:0}}>
                  <Icon name="x" size={11} color="var(--text3)"/>
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}


